// extracted by mini-css-extract-plugin
export default {"disableScroll":"styles_disableScroll__Peeaj","overlay":"styles_overlay__s5s9W"};